export default () => {
  const termsAndConditions = document.querySelector('[data-attribute="contact-terms-and-conditions"]');
  const contactForm = document.querySelector('[data-attribute="contact-form-submit"]');

  if(termsAndConditions && contactForm) {
    termsAndConditions.addEventListener('click', evt => {
      if (termsAndConditions.checked) {
        contactForm.classList.remove('button--disabled');
        contactForm.disabled = false;

        return;
      }

      contactForm.classList.add('button--disabled');
      contactForm.disabled = true;
    });
  }
};



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/contactForm.js